// Utility to consistently mask last names on public-facing pages
// Rules:
// - ALWAYS mask last names on public pages: "John D." instead of "John Doe"
// - Prefer structured fields (first_name, last_name) over display_name
// - If only display_name string is available, mask the last word if there are 2+ words
// - Fallback to email username if no name available

 

export function maskLastNameFromName(name) {
  const raw = String(name || '').trim();
  if (!raw) return '';
  const parts = raw.split(/\s+/);
  if (parts.length === 1) return parts[0];
  const first = parts.slice(0, parts.length - 1).join(' ');
  const last = parts[parts.length - 1];
  const initial = last ? `${last[0].toUpperCase()}.` : '';
  return [first, initial].filter(Boolean).join(' ');
}

export function getPublicDisplayName(user) {
  const first = String(user?.first_name || '').trim();
  const last = String(user?.last_name || '').trim();
  const display = String(user?.display_name || '').trim();
  // Always mask last names for public display
  if (first || last) {
    const masked = [first, last ? `${last[0].toUpperCase()}.` : ''].filter(Boolean).join(' ').trim();
    return masked || (user?.email ? String(user.email).split('@')[0] : 'User');
  }
  if (display) return maskLastNameFromName(display);
  return user?.email ? String(user.email).split('@')[0] : 'User';
}

export function initialsOf(name) {
  const raw = String(name || '').trim();
  if (!raw) return 'U';
  const parts = raw.split(/\s+/).slice(0, 2);
  const initials = parts.map((p) => p[0]?.toUpperCase() || '').join('');
  return initials || 'U';
}

export default getPublicDisplayName;
